<template>
  <a-config-provider
    :theme="{
      token: {
        colorPrimary: '#6d62f7',
      },
    }"
  >
    <router-view />
    <!-- 异步组件加载失败 Modal -->
    <AsyncComponentErrorModal />
  </a-config-provider>
</template>

<script setup lang="ts">
import { getEntryType } from "@peerup/helper"
import { SuiteAdapter } from "@peerup/suite/adapter"
import { useEventListener } from "@vueuse/core"
import { watchEffect } from "vue"
import { useRoute } from "vue-router"

import AsyncComponentErrorModal from "@/components/async-component-error-modal/index.vue"

import { useUserStore } from "./store/modules/user"
import $logger from "./utils/logger"
import { handleTabStatus, initAuthKitListeners } from "./utils/user"

const route = useRoute()
// const router = useRouter()

const userStore = useUserStore()
userStore.init()

// registerRouterForAuthKit(router)
initAuthKitListeners()

useEventListener(
  SuiteAdapter.isMicroApp() ? SuiteAdapter.window : document.querySelector("#accounts-app") as HTMLElement,
  "keydown",
  (event: KeyboardEvent) => {
    if (event.key !== "Enter") return
    window.dispatchEvent(new Event("enter-key"))
  },
)

watchEffect(() => {
  // 路由变化会根据meta配置重置 document.title，如果不希望重置，可以不设置
  if (route.meta?.title && !SuiteAdapter.isMicroApp()) {
    document.title = route.meta.title as string
  }
})

// 初始化userStore状态 监听navigate过来的场景
if (getEntryType() === "navigate") {
  $logger.log("[accounts]通过链接navigate过来的的场景初始化userStore状态")
  userStore.resetState()
  userStore.updateState({ showType: "init" })
  handleTabStatus()
} else if (getEntryType() === "reload") {
  $logger.log("[accounts]reload")
  handleTabStatus()
}
</script>
